import {Component, Input, OnInit} from '@angular/core';
import {CountdownService} from "../../../../../shared/services/countdown/countdown.service";

@Component({
    selector: 'db-percent-offer-counter',
    templateUrl: './percent-offer-counter.component.html',
    styleUrls: ['./percent-offer-counter.component.scss'],
    standalone: false
})
export class PercentOfferCounterComponent implements OnInit {
  @Input() percentOfferPricing: boolean = false;
  @Input() aiPricingCount: boolean;
  public countDown: [string, string, string, string, string, string] = ['0', '0', '0', '0', '0', '0'];

  constructor(
    private countdownService: CountdownService
  ) { }

  ngOnInit() {
    this.countdownService.countdown$.subscribe(countdown => {
      this.countDown = countdown;
    });
  }

}
